import React from "react";
import styled from "styled-components";
import { Elements } from "react-stripe-elements";
import StripeCheckoutHandler from "./StripeCheckoutHandler";
import PaymentRequestButton from "./PaymentRequestForm";
import { Button, PrimaryButton } from "../Button";
import lockSVG from "../../../../images/lock.svg";
import { props } from "ramda";

const BuyForm = ({
  buttonText,
  error,
  price,
  onTokenSuccess,
  paymentOnTokenSuccess,
  onClickButton,
  isLoading,
  showStripeCopy = true,
  withRedBackground,
  withBlueBackground,
  ...props
}) => (
  <BuyFormContainer>
    <StripeCheckoutHandler amount={price} onTokenSuccess={onTokenSuccess}>
      {({ openStripe }) => (
        <React.Fragment>
          <PrimaryButton
            style={{
              ...(isLoading ? { opacity: 0.6 } : {}),
              ...(withRedBackground ? { backgroundColor: "#f74255" } : {}),
              ...(withBlueBackground ? { backgroundColor: "#448EFF" } : {}),
              marginBottom: "10px",
            }}
            onClick={() => {
              if (props.onClickBuy) {
                props.onClickBuy();
              } else {
                openStripe();
                if (window.gtag) {
                  window.gtag("event", "checkout_progress", {
                    event_label: "stripe",
                  });
                  window.gtag("event", "open_stripe");
                }
                if (onClickButton) {
                  onClickButton();
                }
              }
            }}
          >
            {buttonText}
          </PrimaryButton>
          {props.withSeparator && props.canMakePayment && (
            <Separator>
              <Text>
                Please tap the "Pay" button to make a{" "}
                <strong>{`one time purchase of only $${price / 100}`}</strong>
              </Text>
            </Separator>
          )}
          <Elements>
            <PaymentRequestButton amount={price} onTokenSuccess={paymentOnTokenSuccess} />
          </Elements>
          {error ? <Error>{error}</Error> : null}
          {showStripeCopy && (
            <StripeCopy>
              <Lock /> Secure payment by Stripe
            </StripeCopy>
          )}
        </React.Fragment>
      )}
    </StripeCheckoutHandler>
  </BuyFormContainer>
);

const BuyFormContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const Text = styled.p`
  color: #6e788d;
  font-size: 15px !important;
  font-family: "Montserrat";
  font-weight: 500;
  text-align: left;
  @media (max-width: 640px) {
    font-size: 14px !important;
  }
  b {
    color: #f74255;
  }
`;
const Error = styled(Text)`
  color: red;
  margin: 0 !important;
`;

const StripeCopy = styled(Text)`
  display: flex;
  align-items: center;
  margin: auto;
  font-size: 14px;
  color: #4dc384;
  margin-top: 16px;
  margin-bottom: 0px !important;
`;

const Lock = styled.img.attrs({
  src: lockSVG,
})`
  width: 14px;
  height: 16px;
  margin-right: 8px;
`;

const Separator = styled.div`
  border-top: 1px solid #eee;
  padding: 10px 0px;
`;

export default BuyForm;
